import { useState } from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { ChevronDown, MessageCircle, Mail, Phone } from 'lucide-react';

const FAQ_DATA = [
  {
    category: "Pendaftaran & Akun",
    questions: [
      {
        q: "Bagaimana cara mendaftar di MyTentor?",
        a: "Klik tombol 'Daftar' atau 'Mulai Belajar Gratis' di halaman utama, lalu isi formulir dengan nama lengkap, email, dan password. Setelah itu, Anda bisa langsung login dan menggunakan layanan."
      },
      {
        q: "Apakah pendaftaran gratis?",
        a: "Ya, pendaftaran akun di MyTentor sepenuhnya gratis. Anda juga bisa mengakses beberapa try out gratis tanpa biaya. Untuk try out premium dan paket lengkap, tersedia berbagai pilihan harga yang terjangkau."
      },
      {
        q: "Saya lupa password, bagaimana cara reset?",
        a: "Hubungi admin melalui WhatsApp di nomor +62 812 6201 7001 dengan menyebutkan email yang terdaftar. Admin akan membantu reset password Anda dalam waktu 1x24 jam."
      },
      {
        q: "Bisakah saya mengubah data profil?",
        a: "Ya, setelah login Anda dapat mengubah data profil seperti nama, nomor telepon, dan asal sekolah melalui menu Profil di dashboard."
      }
    ]
  },
  {
    category: "Try Out & Latihan Soal",
    questions: [
      {
        q: "Bagaimana cara mengerjakan try out?",
        a: "Setelah login, pilih program (UTBK, CPNS, TNI, dll) dari dashboard atau menu Try Out. Pilih paket try out yang diinginkan, klik 'Mulai', dan kerjakan soal sesuai waktu yang ditentukan. Jawaban akan otomatis tersimpan."
      },
      {
        q: "Apakah ada batasan waktu mengerjakan try out?",
        a: "Ya, setiap try out memiliki durasi waktu yang sudah ditentukan (misalnya 90 menit untuk 100 soal). Timer akan berjalan otomatis dan try out akan otomatis submit ketika waktu habis."
      },
      {
        q: "Bisakah saya melihat pembahasan soal?",
        a: "Ya, setelah menyelesaikan try out, Anda dapat melihat hasil lengkap termasuk jawaban benar, jawaban Anda, dan pembahasan detail untuk setiap soal."
      },
      {
        q: "Berapa kali saya bisa mengerjakan satu try out?",
        a: "Untuk try out gratis, biasanya bisa dikerjakan berkali-kali. Untuk try out berbayar, jumlah percobaan tergantung pada paket yang dibeli (umumnya 1-2 kali)."
      },
      {
        q: "Apakah soal try out sama dengan soal ujian asli?",
        a: "Soal-soal kami disusun berdasarkan kisi-kisi dan pola soal ujian resmi, sehingga memiliki tingkat kesulitan dan format yang mirip. Namun, soal tidak identik dengan soal ujian yang akan keluar."
      }
    ]
  },
  {
    category: "Pembayaran",
    questions: [
      {
        q: "Bagaimana cara membeli paket try out berbayar?",
        a: "Pilih paket yang diinginkan, klik 'Beli'. Anda akan melihat detail harga dan rekening tujuan transfer. Lakukan transfer, lalu upload bukti pembayaran melalui form yang tersedia. Admin akan memverifikasi dan mengaktifkan paket Anda dalam 1x24 jam."
      },
      {
        q: "Metode pembayaran apa saja yang tersedia?",
        a: "Saat ini kami menerima transfer bank ke rekening BCA, BNI, Mandiri, BRI, serta e-wallet (OVO, GoPay, DANA) melalui nomor yang tertera. Pembayaran akan diverifikasi manual oleh admin."
      },
      {
        q: "Berapa lama verifikasi pembayaran?",
        a: "Verifikasi pembayaran membutuhkan waktu maksimal 1x24 jam di hari kerja. Untuk konfirmasi lebih cepat, Anda dapat menghubungi admin via WhatsApp setelah mengunggah bukti transfer."
      },
      {
        q: "Apakah bisa refund jika sudah bayar?",
        a: "Pengembalian dana dapat diajukan dalam 7 hari jika layanan belum digunakan sama sekali. Jika sudah mengakses try out atau materi, tidak ada pengembalian dana. Hubungi admin untuk informasi lebih lanjut."
      }
    ]
  },
  {
    category: "Event Try Out",
    questions: [
      {
        q: "Apa itu Event Try Out?",
        a: "Event Try Out adalah try out yang dijadwalkan dengan waktu tertentu, biasanya untuk simulasi ujian massal. Peserta harus terdaftar dan memiliki nomor peserta untuk mengikuti event."
      },
      {
        q: "Bagaimana cara ikut Event Try Out?",
        a: "Untuk event publik, daftar melalui halaman Event atau hubungi admin. Anda akan mendapatkan nomor peserta unik. Saat event dimulai, masukkan nomor peserta untuk mulai mengerjakan."
      },
      {
        q: "Apakah Event Try Out berbayar?",
        a: "Tergantung event-nya. Ada event gratis dan ada event berbayar. Informasi harga akan tertera jelas di detail event."
      }
    ]
  },
  {
    category: "Teknis",
    questions: [
      {
        q: "Browser apa yang direkomendasikan?",
        a: "Kami merekomendasikan Google Chrome, Mozilla Firefox, atau Microsoft Edge versi terbaru untuk pengalaman terbaik. Pastikan JavaScript diaktifkan di browser Anda."
      },
      {
        q: "Apakah bisa diakses dari HP?",
        a: "Ya, website MyTentor responsive dan dapat diakses dari smartphone, tablet, maupun komputer/laptop. Namun untuk try out, kami sarankan menggunakan layar yang lebih besar agar lebih nyaman."
      },
      {
        q: "Bagaimana jika koneksi internet terputus saat try out?",
        a: "Jawaban Anda tersimpan secara otomatis setiap kali memilih jawaban. Jika koneksi terputus, login kembali dan lanjutkan try out. Waktu akan tetap berjalan sesuai durasi awal."
      }
    ]
  }
];

function FAQItem({ question, answer }) {
  const [isOpen, setIsOpen] = useState(false);
  
  return (
    <div className="border border-slate-200 rounded-lg overflow-hidden">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between p-4 text-left bg-white hover:bg-slate-50 transition-colors"
      >
        <span className="font-medium text-slate-900 pr-4">{question}</span>
        <ChevronDown className={`w-5 h-5 text-slate-400 shrink-0 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>
      {isOpen && (
        <div className="p-4 pt-0 bg-white">
          <p className="text-slate-600 text-sm leading-relaxed">{answer}</p>
        </div>
      )}
    </div>
  );
}

export default function FAQPage() {
  return (
    <div className="min-h-screen bg-slate-50 flex flex-col">
      <Header />
      
      <main className="flex-1 py-12 px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="text-3xl font-bold text-slate-900 mb-2">Pusat Bantuan & FAQ</h1>
            <p className="text-slate-500">Temukan jawaban atas pertanyaan yang sering diajukan</p>
          </div>
          
          {/* FAQ Categories */}
          <div className="space-y-8 mb-12">
            {FAQ_DATA.map((category) => (
              <div key={category.category}>
                <h2 className="text-lg font-semibold text-slate-900 mb-4">{category.category}</h2>
                <div className="space-y-2">
                  {category.questions.map((item, idx) => (
                    <FAQItem key={idx} question={item.q} answer={item.a} />
                  ))}
                </div>
              </div>
            ))}
          </div>
          
          {/* Still Need Help */}
          <div className="bg-white rounded-xl border border-slate-200 p-8 text-center">
            <h2 className="text-xl font-semibold text-slate-900 mb-2">Masih ada pertanyaan?</h2>
            <p className="text-slate-500 mb-6">Tim kami siap membantu Anda</p>
            
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a 
                href="https://wa.me/6281262017001"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 px-6 py-3 bg-green-600 hover:bg-green-700 text-white rounded-lg transition-colors"
              >
                <MessageCircle className="w-5 h-5" />
                Chat WhatsApp
              </a>
              <a 
                href="mailto:mytentor2017@gmail.com"
                className="flex items-center gap-2 px-6 py-3 bg-slate-100 hover:bg-slate-200 text-slate-700 rounded-lg transition-colors"
              >
                <Mail className="w-5 h-5" />
                Email Kami
              </a>
              <a 
                href="tel:+6281262017001"
                className="flex items-center gap-2 px-6 py-3 bg-slate-100 hover:bg-slate-200 text-slate-700 rounded-lg transition-colors"
              >
                <Phone className="w-5 h-5" />
                Telepon
              </a>
            </div>
            
            <p className="text-sm text-slate-400 mt-6">
              Jam operasional: Senin - Sabtu, 08.00 - 19.00 WIB
            </p>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
}
